module.exports = ".loading .card {\n  min-height: 500px;\n}\n.loading .loading-container {\n  position: absolute;\n  left: 45%;\n  top: 45%;\n}\n.loading .loading-container .text {\n  display: inline-block;\n  margin-left: 7px;\n  line-height: 5px;\n  vertical-align: text-top;\n}\n.loading .loading-container mat-progress-spinner {\n  display: inline-block;\n}\n.foot-note {\n  font-size: 14px;\n  float: right;\n  margin-right: 5%;\n  margin-bottom: 2%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/data/data.component.less
// module id = ./src/app/projects/project/data/data.component.less
// module chunks = main